module.exports = __webpack_public_path__ + "img/home-size-chart.d7bc80ba.png";